import { IEditBehavior, IEditBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanHidableOnEditing } from "../../../beans/objects";

export class EditBehaviorTranslator {
  from(bean: IObjectBeanHidableOnEditing): IEditBehavior {
    return {
      isVisible: (bean["@vanish"] !== "1"),
    };
  }

  to(o: IEditBehaviorSpecifiable) {
    return {
      vanish: o.editBehavior.isVisible
        ? undefined
        : "1",
    };
  }
}
